var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteBin = function SvgDeleteBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 197.516 197.516"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.758 170.083V72.649h15v97.434zm60-97.434h-15v97.434h15zM140.539 0v12.631h34.885v47.746h-10.525v137.139H32.617V60.377H22.092V12.631h34.883V0zm9.359 60.377H47.617v122.139h102.281zm-24.359-32.746V15H71.975v12.631H37.092v17.585h123.332V27.631z"
  })));
};
export default SvgDeleteBin;